import { MediaItem } from 'components/ComponentMultiVideoV2/video-inteface';

export const showMediaOssUrl = '//resources.jimage.cn/';

export const transformSnapshotPath = (item: MediaItem): MediaItem => {
  return {
    ...item,
    path:
      showMediaOssUrl +
      (item.path.startsWith('/') ? item.path.slice(1) : item.path) +
      '?x-oss-process=video/snapshot,t_3000,f_jpg,m_fast',
  };
};
